// extracted by mini-css-extract-plugin
export var content = "_2s-3";
export var contentWrapper = "_2s-2";
export var fullWidthButton = "_2s-4";
export var heroImage = "_2s-6";
export var logo = "_2s-1";
export var logoContainer = "_2s-0";
export var panel = "_2s-5";